import type { ReactNode } from 'react';

export const FilterField = ({ label, children }: { label: string; children: ReactNode }) => (
  <div className="form-group">
    <span style={{ display: 'block', fontWeight: 600, marginBottom: 4 }}>{label}</span>
    {children}
  </div>
);
